module.exports = __webpack_public_path__ + "static/12.1_classical_greece-249643bc14256bb3ba2adab4334e80f7.pdf";